<section
  class="flex flex-col w-full h-screen bg-white-101 justify-center items-center">
  <p class="text-blue-1000 text-9xl">403</p>
  <p class="text-gray-500 text-4xl pt-2">ACCESS FORBIDDEN</p>
</section>
